(function (angular) {
	'use strict';

	angular
		.module('updatedDocumentsModule')
		.controller('UpdatedDocuments', [
			'$http',
			'$window',
			'APP_BASE_PATH',
			UpdatedDocumentsFunction
		]);

	function UpdatedDocumentsFunction($http, $window, APP_BASE_PATH) {
		var updatedDocuments = this;
		
		updatedDocuments.ackWebDocCheckbox = false;
		updatedDocuments.showErrorMessage = false;
		
		updatedDocuments.submitted = false;
		
		updatedDocuments.submit = function() {
			if(updatedDocuments.ackWebDocCheckbox && !updatedDocuments.submitted) {
				updatedDocuments.submitted = true;
				
				$http.post(APP_BASE_PATH + '/webdocs/accept.json').then(function() {					
					$window.location = APP_BASE_PATH;
				});
			} else {
				updatedDocuments.showErrorMessage = true;
			}
		};
	}
})(window.angular);